<template>
  <div id="chart-line-item-item-box">
    <div class="chart-title">
      <img class="charts-icon" :src="require('@/assets/images/largescreen/charts-icon.png')" alt="">
      <dv-decoration-1/>
      <span>{{ areaName === 'china' ? '全国' : areaName }}装机数量</span>
    </div>
    <div id="chart-line-item"/>
  </div>
</template>

<script>
import resize from '@/utils/resize'

export default {
  mixins: [resize],
  name: "bodyLeftTop",
  data() {
    return {
      chart: null,
      mapJsonData: {
        dayInstalled: [],
        comdate: [],
      }
    }
  },
  props: {
    areaName: {
      type: String,
      default: 'china'
    },
    dayInstallCount: {
      type: Array,
      default() {
        return []
      }
    }
  },
  created() {
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart()
    })
    
    // 监听屏幕方向变化
    window.addEventListener('orientationchange', this.handleOrientationChange)
  },
  watch: {
    dayInstallCount: {
      handler(val) {
        this.mapJsonData =  {
          dayInstalled: [],
          comdate: [],
        }
        for (var i = 0; i < val.length; i++) {
          this.mapJsonData.dayInstalled.push(val[i].dayInstalled)
          this.mapJsonData.comdate.push(val[i].comdate)
        }
        // ✅ 优化：只更新数据，不重新初始化图表
        this.updateChartData()
      },
      deep: true,
      immediate: true // ✅ 确保初始数据也能渲染
    }
  },
  beforeDestroy() {
    if (!this.chart) {
      return
    }
    this.chart.dispose()
    this.chart = null
    
    // 移除监听器
    window.removeEventListener('orientationchange', this.handleOrientationChange)
  },
  methods: {
    handleOrientationChange() {
      // 屏幕方向变化后，延迟重新渲染图表
      setTimeout(() => {
        if (this.chart) {
          this.chart.resize()
        }
      }, 300)
    },
    initChart() {
      // ✅ 优化：避免重复初始化
      if (!this.chart) {
        this.chart = this.$echarts.init(document.getElementById('chart-line-item'))
      }
      this.setOptions()
    },
    // ✅ 新增：仅更新图表数据，不重新初始化
    updateChartData() {
      if (!this.chart) {
        // ✅ 确保DOM元素存在后再初始化
        this.$nextTick(() => {
          this.initChart()
        })
        return
      }
      
      // 只更新series数据和x轴数据
      this.chart.setOption({
        xAxis: [{
          data: this.mapJsonData.comdate
        }],
        series: [
          {
            data: this.mapJsonData.dayInstalled
          }
        ]
      })
    },
    setOptions() {
      // ✅ 检测是否为移动端和1080p大屏
      const isMobile = window.innerWidth <= 768;
      const isLargeScreen = window.innerWidth >= 1920 && window.innerHeight >= 1080;
      
      // ✅ 根据屏幕尺寸动态调整字体大小
      const fontSize = isLargeScreen ? 14 : (isMobile ? 9 : 10);
      const nameFontSize = isLargeScreen ? 16 : (isMobile ? 12 : 14);
      
      this.chart.setOption({
        color: ['#24CBF1', '#868EF9', '#E6A23C', '#09F9CD', '#EF557D'],
        legend: {
          // icon: 'circle',
          itemWidth: isMobile ? 12 : 15,
          itemHeight: isMobile ? 6 : 8,
          itemGap: isMobile ? 5 : 8,
          align: "left", // icon 位于文字位置
          data: ['装机台数'],
          textStyle: {
            color: '#fff',
            fontSize: fontSize // ✅ 动态字体大小
          },
          left: 'center', // ✅ 居中，避免与Y轴名称重叠
          top: 0
        },
        xAxis: [{
          type: 'category',
          data: this.mapJsonData.comdate,
          boundaryGap: true,
          axisTick: {
            show: false
          },
          axisLabel: {
            rotate: 30,
            textStyle: {
              fontSize: fontSize // ✅ 动态字体大小
            }
          },
          axisLine: {
            lineStyle: {
              color: '#fff',
            }
          },
          //网格样式
          splitLine: {
            show: true,
            lineStyle: {
              color: 'rgba(125, 155, 243, .2)',
              width: .5,
              type: 'solid'
            }
          },
        }],
        dataZoom: [//滑动条
          {
            type: 'inside',
            realTime: true,
            roam: true,
            startValue: 0, // 从头开始。
            endValue: 7  // 一次性展示6个。
          }
        ],
        yAxis: [{
          type: 'value',
          name: '单位/台',
          minInterval: 1,
          nameTextStyle: {
            fontSize: nameFontSize, // ✅ 动态字体大小
            color: "#fff",
            padding: [0, -20, -10, 0],
          },
          axisTick: {
            show: false//隐藏y坐标轴刻度
          },
          axisLabel: {//y轴字体样式
            rotate: 60,
            textStyle: {
              fontSize: fontSize // ✅ 动态字体大小
            }
          },
          axisLine: {
            show: true, //隐藏y坐标轴
            lineStyle: {
              color: '#fff'
            }
          },
          //网格样式
          splitLine: {
            show: true,
            lineStyle: {
              color: 'rgba(125, 155, 243, .2)',
              width: .5,
              type: 'solid'
            }
          },
        }],
        grid: {
          left: 0,
          right: 10,
          bottom: 0,
          top: 30,
          containLabel: true
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'line'
          },
          padding: [5, 10],
          formatter: function (params) {
            let htmlStr = '';
            htmlStr += params[0].name + '<br/> ';
            for (let i = 0; i < params.length; i++) {
              htmlStr += '<div style="display:inline-block;width:10px;height:10px;border-radius:50%;background:' + params[i].color + '"></div>' +
                params[i].seriesName + ':' + params[i].value + '台<br/>';
            }
            return htmlStr
          }
        },
        series: [
          {
            name: '装机台数',
            type: 'line',
            stack: '分析1',
            smooth: false,  //这个是把线变成曲线
            areaStyle: {}, //填充区域样式
            data: this.mapJsonData.dayInstalled
          },
          // {
          //   name: '分析2',
          //   type: 'line',
          //   stack: '分析2',
          //   smooth: true,  //这个是把线变成曲线
          //   areaStyle: {}, //填充区域样式
          //   data: this.mapJsonData.dsl
          // },
        ]
      })
    },
  }
}
</script>

<style lang="scss" scoped>
#chart-line-item-item-box {
  background: rgba(125, 155, 243, .2);
  height: calc(33.3%);
  //margin-bottom: 10px;
  .chart-title {
    display: flex;
    align-items: center; // ✅ 垂直居中对齐
    color: #fff;
    font-weight: bolder;
    padding: 5px 10px;
    background: rgba(125, 155, 243, .2);
    position: relative;

    .charts-icon {
      width: 20px;
      height: 25px;
      position: absolute;
      left: 15px;
      top: 0;
    }

    .dv-decoration-1 {
      width: 50px;
      height: 18px;
    }
  }

  #chart-line-item {
    height: calc(100% - 30px);
  }
}

// 平板端和手机横屏适配
@media screen and (min-width: 769px) {
  #chart-line-item-item-box {
    .chart-title {
      span {
        font-size: 12px !important;
      }
    }
  }
}

// 手机横屏特殊处理
@media screen and (orientation: landscape) and (max-height: 768px) {
  #chart-line-item-item-box {
    height: calc((100% - 30px) / 3) !important; // ✅ 三等分，减去边距和padding
    margin-bottom: 10px !important;
  }
}

// 手机竖屏适配
@media screen and (max-width: 768px) and (orientation: portrait) {
  #chart-line-item-item-box {
    height: 300px !important;
    margin-bottom: 10px;
    
    .chart-title {
      padding: 8px 10px !important;
      
      span {
        font-size: 13px !important;
        margin-left: 35px !important;
      }
      
      .charts-icon {
        width: 16px !important;
        height: 20px !important;
        left: 10px !important;
      }
      
      .dv-decoration-1 {
        width: 40px !important;
        height: 15px !important;
      }
    }
    
    #chart-line-item {
      height: calc(100% - 40px) !important;
    }
  }
}

// ✅ 1080p 屏幕专属优化
@media screen and (min-width: 1920px) and (max-width: 2560px) and (min-height: 1080px) and (max-height: 1440px) {
  #chart-line-item-item-box {
    .chart-title {
      span {
        font-size: 18px !important; // ✅ 增大标题字体
      }
      
      .charts-icon {
        width: 24px !important;
        height: 30px !important;
      }
      
      .dv-decoration-1 {
        width: 70px !important;
        height: 24px !important;
      }
    }
  }
}
</style>
